/**
 * The groups list URL, derived from the current group detail pathname
 * (`…/groups/:groupId` → `…/groups`). Keeps the mount point of the host unhardcoded.
 *
 * @param {string} pathname
 */
export const getGroupsListPath = (pathname) =>
  pathname.replace(/\/+$/, '').replace(/\/[^/]+$/, '');

/**
 * The member detail URL (`…/members/:memberId`), derived from a pathname under the groups routes
 * (`…/groups` or `…/groups/:groupId`).
 *
 * @param {string} pathname
 * @param {string} memberId
 */
export const getMemberDetailPath = (pathname, memberId) =>
  `${getGroupsListPath(pathname).replace(/\/groups$/, '')}/members/${memberId}`;

/**
 * The in-app path a page was opened from (`location.state.backTo`), or undefined. Only absolute
 * app paths count: a URL or a protocol-relative `//host` is ignored.
 *
 * @param {{ backTo?: unknown }|null|undefined} state
 */
export const getBackTo = (state) => {
  const target = state?.backTo;
  return typeof target === 'string' && target.startsWith('/') && !target.startsWith('//') ? target : undefined;
};

/** Up to two initials from a display name, for `Avatar`. */
export const initialsOf = (name) =>
  String(name ?? '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase();

/** The first two letters of a group name, upper case ("Engineering" -> "EN"): the group's avatar text. */
export const groupAvatarText = (name) =>
  String(name ?? '')
    .replace(/[^\p{L}\p{N}]/gu, '')
    .slice(0, 2)
    .toUpperCase();
